//changes from haseeb.

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { UsePortalApi } from "../../../utils/UsePortalApi";

export const LabResultsWithoutAttachment = createAsyncThunk(
  "LabResultsWithoutAttachment",
  async (payload, { dispatch, getState }) => {
    try {
      dispatch(gettingGetScreeningTemplateHTML(""));
      const response = await UsePortalApi(
        `Patient/LabResultsWithoutAttachment`,
        "Post",
        payload,
        true
      );
      if (response) {
        console.log(response , "response")
        response[0].hasOwnProperty('entry') ? dispatch(gettingGetScreeningTemplateHTMLSuccess(response[0].entry)) : dispatch(gettingGetScreeningTemplateHTMLClear())

      } else {
        dispatch(
          gettingGetScreeningTemplateHTMLFailed(
            response?.errorMessage
          )
        );
      }
    } catch (error) {
      dispatch(gettingGetScreeningTemplateHTMLFailed(error));
    }
  }
);

const GetScreeningTemplateHTMLSlice = createSlice({
  name: "LabResultsWithoutAttachment",
  initialState: {
    Reports: null,
    isFetching: false,
    error: false,
  },
  reducers: {
    gettingGetScreeningTemplateHTML: (state, action) => {
      state.Reports = null;
      state.isFetching = true;
      state.error = false;
    },
    gettingGetScreeningTemplateHTMLSuccess: (state, action) => {
      state.Reports = action.payload;
      state.isFetching = false;
      state.error = false;
    },
    gettingGetScreeningTemplateHTMLFailed: (state, action) => {
      state.Reports = null;
      state.isFetching = false;
      state.error = true;
    },
    gettingGetScreeningTemplateHTMLClear: (state, action) => {
      state.Reports = null;
      state.isFetching = false;
      state.error = false;
    },
  },
});
export const {
  gettingGetScreeningTemplateHTML,
  gettingGetScreeningTemplateHTMLSuccess,
  gettingGetScreeningTemplateHTMLFailed,
  gettingGetScreeningTemplateHTMLClear,
} = GetScreeningTemplateHTMLSlice.actions;
export default GetScreeningTemplateHTMLSlice.reducer;
